<template>
  <div
    class="price-page-header d-flex flex-column"
    :class="isMobile ? 'ga-4' : 'ga-6'"
  >
    <div
      v-if="!hideTitleAndPhone"
      class="d-flex"
      :class="isMobile ? 'flex-column' : 'align-center justify-space-between ga-8'"
    >
      <h1
        class="text--text"
        :class="isMobile ? 'text-h6' : 'text-h5'"
        data-qa="lpu_page_price_title"
      >
        {{ title }}
      </h1>
      <div
        v-if="!isMobile && appointmentPhone"
        class="d-flex align-center ga-2 flex-shrink-0 text--text"
        data-qa="lpu_page_price_phone"
      >
        <span
          class="ui-icon-ui-call ui-icon-fz-smaller"
          aria-hidden="true"
        />
        <span class="text-subtitle-1">{{ appointmentPhone }}</span>
      </div>
    </div>

    <PricePageDescription
      :lpu="lpu"
      :town-name="townName"
      :currency-abbreviation="currencyAbbreviation"
      :price-range="priceRange"
      :price-range-doctors="priceRangeDoctors"
      :price-range-mrt="priceRangeMrt"
      :price-range-kt="priceRangeKt"
      :price-range-uzi="priceRangeUzi"
      :price-range-rentgen="priceRangeRentgen"
      :price-range-uslugi="priceRangeUslugi"
    />
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import useIsMobile from 'src/composables/useIsMobile'
import tStatic from 'src/components/pages/[town-translit]/lpu/[lpu-translit]/_functions/tStatic'
import getPricePageTitle from 'src/components/pages/[town-translit]/lpu/[lpu-translit]/price/_components/PriceSection/components/PriceHeader/functions/getPricePageTitle'
import PricePageDescription from 'src/components/pages/[town-translit]/lpu/[lpu-translit]/price/_components/PriceSection/components/PriceHeader/PricePageDescription.vue'
import type { Lpu } from 'src/components/pages/[town-translit]/lpu/[lpu-translit]/_types'
import type { PriceRangeTuple } from 'src/components/pages/[town-translit]/lpu/[lpu-translit]/price/_components/PriceSection/components/PriceHeader/types'

const props = defineProps<{
  lpu: Lpu
  townName: string
  currencyAbbreviation: string
  hideTitleAndPhone?: boolean
  appointmentPhone?: string
  priceRange?: PriceRangeTuple
  priceRangeDoctors?: PriceRangeTuple
  priceRangeMrt?: PriceRangeTuple
  priceRangeKt?: PriceRangeTuple
  priceRangeUzi?: PriceRangeTuple
  priceRangeRentgen?: PriceRangeTuple
  priceRangeUslugi?: PriceRangeTuple
}>()

const isMobile = useIsMobile()
const title = computed(() => (
  isMobile.value
    ? getPricePageTitle(props.lpu)
    : tStatic('Цены на услуги')
))
</script>

<style scoped lang="scss">
.price-page-header {
  position: relative;
}
</style>
